<template lang="html">
  <div text-center d-flex align-center>

    <!-- Dialog de confirmação para exclusão de um arquivo -->
    <c-confirm-dialog v-model="dialogConfirmaExclusao" @yes="excluirArquivo()" titulo="Deseja realmente excluir o arquivo?">
    </c-confirm-dialog>

    <!-- Tabela com os arquivos -->
    <v-data-table
      :headers="headers"
      :items="listaArquivos"
      :search="search"
      :no-data-text="'Nenhum arquivo encontrado'"
      must-sort
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items-per-page="itemsPerPage"
      :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >

      <!-- Formata coluna 'Opções' -->
      <template v-slot:item.opcoes="props">

        <!-- Editar informações do arquivo -->
        <c-tooltip-btn
          icon="edit"
          color="primary"
          tooltip="Editar informações do arquivo"
          @click="toEditarArquivo(props.item.idArquivo)"
          v-if="administradorPRPPG || projetoPesquisa.coordenador"
        ></c-tooltip-btn>

        <!-- Excluir arquivo -->
        <c-tooltip-btn
          icon="delete"
          color="primary"
          tooltip="Excluir arquivo"
          @click="toExcluirArquivo(props.item.idArquivo)"
          v-if="administradorPRPPG || projetoPesquisa.coordenador"
        ></c-tooltip-btn>

      </template>

      <!-- Formata o nome do arquivo -->
      <template v-slot:item.nome="props">
        <a :href="api_url + '/pesquisa/projetos/' + idProjetoPesquisa + '/arquivos/' + props.item.idArquivo">
          <v-icon>vertical_align_bottom</v-icon>{{ props.item.nome.trim() }}
        </a>
      </template>

      <!-- Formata a data de inclusão -->
      <template v-slot:item.dtInclusao="props">{{dates.format(props.item.dtInclusao)}}</template>

      <!-- Número total de arquivos -->
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaArquivos.length }} {{ listaArquivos.length > 1 ? 'arquivos' : 'arquivo' }}
      </template>

    </v-data-table>

    <br><br>

    <v-card-actions>

      <!-- Botão "Voltar" -->
      <v-btn color="primary" @click="toVoltar()">Voltar</v-btn>

      <v-spacer></v-spacer>

      <!-- Botão "Adicionar arquivo" -->
      <v-btn color="primary" @click="toAdicionarArquivo()" v-if="administradorPRPPG || projetoPesquisa.coordenador">Adicionar Arquivo</v-btn>

      <!-- Botão "Avançar" -->
      <v-btn color="primary" @click="toAvancar()">Avançar</v-btn>

    </v-card-actions>
    

  </div>
</template>

<script>
import projetos from '@/utils/projetos'
import dates from '@/utils/dates'
import ConfirmDialog from '@/components/c-confirm-dialog'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import TootipButton from '@/components/c-tooltip-btn'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: () => ({
    dialogConfirmaExclusao: false,
    idArquivoProjetoPesquisaExclusao: '',
    listaArquivos: [],
    api_url: process.env.API_BASE_URL,
    dates: dates,
    search: null,
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Tipo', align: 'left', value: 'tipoArquivo.descricao' },
      { text: 'Data de inclusão', align: 'left', value: 'dtInclusao' },
      { text: 'Observação', align: 'left', value: 'observacao' },
      { text: 'Opções', align: 'left', value: 'opcoes' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'administradorPRPPG'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

    // Carrega os arquivos do projeto de pesquisa.
    carregaArquivosProjetoPesquisa: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos...' })
      projetos.getArquivosProjetoPesquisa(this.idProjetoPesquisa)
      .then(response => {
        this.listaArquivos = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos...' })
      })
    },

    // Edita as informações do arquivo.
    toEditarArquivo: function (idArquivoProjetoPesquisa) {
      this.$router.push({ name: 'EditarProjetoPesquisaArquivo', params: {idProjetoPesquisa: this.idProjetoPesquisa, idArquivoProjetoPesquisa: idArquivoProjetoPesquisa} })
    },

    // Voltar para a aba anterior.
    toVoltar: function () {
      this.$router.push({ name: 'ProjetoPesquisaOrgaosFinanciadores', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Avançar para a próxima aba.
    toAvancar: function () {
      this.$router.push({ name: 'ProjetoPesquisaOutrasInformacoes', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Adiciona um arquivo.
    toAdicionarArquivo: function () {
      this.$router.push({ name: 'ProjetoPesquisaAdicionarArquivo', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Exclui um arquivo (abre dialog de confirmação).
    toExcluirArquivo: function (idArquivoProjetoPesquisa) {
      this.idArquivoProjetoPesquisaExclusao = idArquivoProjetoPesquisa
      this.dialogConfirmaExclusao = true
    },

    // Exclui um arquivo (chama endpoint para exclusão).
    excluirArquivo: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo arquivo...' })
      projetos.deleteArquivoProjetoPesquisa(this.idProjetoPesquisa, this.idArquivoProjetoPesquisaExclusao)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.carregaArquivosProjetoPesquisa()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo arquivo...' })
      })
    }
  },
  mounted () {
    // Carrega os arquivos do projeto de pesquisa.
    this.carregaArquivosProjetoPesquisa()
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-tooltip-btn': TootipButton,
    'c-confirm-dialog': ConfirmDialog
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// arquivos.vue?6c232c9e